import React, { useContext, useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import * as AiIcons from "react-icons/ai";
import { NavLink } from "react-router-dom";

import { AppContext } from "../../Contexts/AppContext";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

const Header = () => {
  const menuBarRef = useRef(null);
  const divRef = useRef(null);
  const context = useContext(AppContext);

  const [commerceMenu, setCommerceMenu] = useState(false);
  const [financialMenu, setFinancialMenu] = useState(false);
  const [VolunteerMenu, setVolunteerMenu] = useState(false);
  const [BusinessMenu, setBusinessMenu] = useState(false);

  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");
  const [currentDropdown, setCurrentDropdown] = useState("");
  // const [currentFont, setCurrentFont] = useState("");

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    setCurrentBG(
      context.isLight
        ? context.currentTheme[context.current].bg
        : context.currentTheme[context.current].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme[context.current].text
        : context.currentTheme[context.current].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme[context.current].tertiary_color
        : context.currentTheme[context.current].bg
    );
    setCurrentDropdown(
      context.isLight
        ? context.currentTheme[context.current].dropdown
        : context.currentTheme[context.current].dark_dropdown
    );
    // setCurrentFont(context.currentTheme["default"].font);
    if (width >= 1024) {
      menuBarRef.current.closeTrigger();
    }

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  }, [context, width]);

  return (
    <>
      <nav
        ref={divRef}
        className="sticky inset-0 z-20 flex h-14 items-center justify-center px-2 py-2 transition-all duration-500 md:px-4"
        style={{
          backgroundColor: currentBG,
          color: currentText,
          // fontFamily: currentFont,
        }}
      >
        <div className="mx-auto flex w-screen max-w-screen-xl flex-wrap items-center justify-between">
          <div className="flex items-center justify-center">
            <NavLink to="/" className="flex items-center">
              <div className="flex flex-col xs:mr-2">
                <p
                  className="logo-font text-base font-bold xs:text-xl sm:text-2xl"
                  style={{ lineHeight: 0.75 }}
                >
                  COMMON SPACE
                </p>
                <p
                  className="logo-font text-xs text-gray-500  xs:text-sm sm:text-base"
                  style={{ lineHeight: 1 }}
                >
                  Whatever it is, we got it
                </p>
              </div>
            </NavLink>
            <AiIcons.AiOutlineSync
              onClick={() => {
                localStorage.setItem("isLight", !context.isLight);
                context.setTheme(!context.isLight);
              }}
              className="ml-2 cursor-pointer text-2xl active:animate-spin"
            />
          </div>
          <div className="xs-center hidden w-full justify-between text-sm md:w-auto lg:flex">
            <ul className="mt-4 flex flex-col font-medium md:mt-0 md:flex-row md:space-x-8">
              <li className="text-center">
                <NavLink
                  to="/"
                  className="block py-2 pr-4 pl-3 md:border-0 md:p-0 md:hover:bg-transparent"
                >
                  Home
                </NavLink>
              </li>
              <li className="relative">
                <button
                  className="flex w-full items-center justify-between py-2 pr-4 pl-3 font-medium md:w-auto md:border-0 md:p-0"
                  onMouseEnter={() => setCommerceMenu(true)}
                  onMouseLeave={() => setCommerceMenu(false)}
                >
                  E-Commerce{" "}
                  <svg
                    aria-hidden="true"
                    className={`ml-1 h-5 w-5 ${
                      commerceMenu ? "rotate-180" : "rotate-0"
                    } transition-all delay-200 md:h-4 md:w-4`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <AnimatePresence>
                  {commerceMenu && (
                    <motion.div
                      initial={{
                        opacity: 0,
                      }}
                      animate={{
                        opacity: 1,
                        transition: {
                          duration: 0.2,
                          ease: "easeInOut",
                        },
                      }}
                      exit={{
                        opacity: 0,
                        transition: {
                          delay: 0.2,
                          ease: "easeInOut",
                        },
                      }}
                      className="absolute right-1/2 top-[38px] z-10 grid min-w-max max-w-md translate-x-[50%] grid-cols-2 rounded-b-lg text-sm md:grid-cols-3"
                      style={{ backgroundColor: currentDropdown }}
                      onMouseEnter={() => setCommerceMenu(true)}
                      onMouseLeave={() => setCommerceMenu(false)}
                      title="Click to change the theme"
                    >
                      <div
                        className="absolute top-[-15px] left-1/2 translate-x-[-50%] border-r-[15px] border-b-[15px] border-l-[15px] border-l-transparent border-r-transparent"
                        style={{ borderBottomColor: currentDropdown }}
                      ></div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4">
                          <li className="text-center">
                            <NavLink to="/commerce/esper">ESPER Honey</NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4">
                          <li className="text-center">
                            <NavLink to="/commerce/tipsy">Tipsy Monkey</NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4"></ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
              <li className="relative">
                <button
                  className="flex w-full items-center justify-between py-2 pr-4 pl-3 font-medium md:w-auto md:border-0 md:p-0"
                  onMouseEnter={() => setFinancialMenu(true)}
                  onMouseLeave={() => setFinancialMenu(false)}
                >
                  Financial App{" "}
                  <svg
                    aria-hidden="true"
                    className={`ml-1 h-5 w-5 ${
                      financialMenu ? "rotate-180" : "rotate-0"
                    } transition-all delay-200 md:h-4 md:w-4`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <AnimatePresence>
                  {financialMenu && (
                    <motion.div
                      initial={{
                        opacity: 0,
                      }}
                      animate={{
                        opacity: 1,
                        transition: {
                          duration: 0.2,
                          ease: "easeInOut",
                        },
                      }}
                      exit={{
                        opacity: 0,
                        transition: {
                          delay: 0.2,
                          ease: "easeInOut",
                        },
                      }}
                      className="absolute right-1/2 top-[38px] z-10 grid min-w-max max-w-md translate-x-[50%] grid-cols-2 rounded-b-lg text-sm md:grid-cols-3"
                      style={{ backgroundColor: currentDropdown }}
                      onMouseEnter={() => setFinancialMenu(true)}
                      onMouseLeave={() => setFinancialMenu(false)}
                      title="Click to change the theme"
                    >
                      <div
                        className="absolute top-[-15px] left-1/2 translate-x-[-50%] border-r-[15px] border-b-[15px] border-l-[15px] border-l-transparent border-r-transparent"
                        style={{ borderBottomColor: currentDropdown }}
                      ></div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4">
                          <li className="text-center">
                            <NavLink to="/soon">Financial Mars</NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4">
                          <li className="text-center">
                            <NavLink to="/soon">MyFinancial</NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4">
                          <li className="text-center">
                            <NavLink to="/soon">MCM Finance</NavLink>
                          </li>
                        </ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
              <li className="relative">
                <button
                  className="flex w-full items-center justify-between py-2 pr-4 pl-3 font-medium md:w-auto md:border-0 md:p-0"
                  onMouseEnter={() => setBusinessMenu(true)}
                  onMouseLeave={() => setBusinessMenu(false)}
                >
                  Business{" "}
                  <svg
                    aria-hidden="true"
                    className={`ml-1 h-5 w-5 ${
                      BusinessMenu ? "rotate-180" : "rotate-0"
                    } transition-all delay-200 md:h-4 md:w-4`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <AnimatePresence>
                  {BusinessMenu && (
                    <motion.div
                      initial={{
                        opacity: 0,
                      }}
                      animate={{
                        opacity: 1,
                        transition: {
                          duration: 0.2,
                          ease: "easeInOut",
                        },
                      }}
                      exit={{
                        opacity: 0,
                        transition: {
                          delay: 0.2,
                          ease: "easeInOut",
                        },
                      }}
                      className="absolute right-1/2 top-[38px] z-10 grid min-w-max max-w-md translate-x-[50%] grid-cols-2 rounded-b-lg text-sm md:grid-cols-3"
                      style={{ backgroundColor: currentDropdown }}
                      onMouseEnter={() => setBusinessMenu(true)}
                      onMouseLeave={() => setBusinessMenu(false)}
                      title="Click to change the theme"
                    >
                      <div
                        className="absolute top-[-15px] left-1/2 translate-x-[-50%] border-r-[15px] border-b-[15px] border-l-[15px] border-l-transparent border-r-transparent"
                        style={{ borderBottomColor: currentDropdown }}
                      ></div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4">
                          <li className="text-center">
                            <NavLink to="/business/mad_gamers">
                              Mad Gamers
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4">
                          <li className="text-center">
                            <NavLink to="/business/yarn_heaven">
                              Yarn Heaven
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4"></ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
              <li className="relative">
                <button
                  className="flex w-full items-center justify-between py-2 pr-4 pl-3 font-medium md:w-auto md:border-0 md:p-0"
                  onMouseEnter={() => setVolunteerMenu(true)}
                  onMouseLeave={() => setVolunteerMenu(false)}
                >
                  Volunteer{" "}
                  <svg
                    aria-hidden="true"
                    className={`ml-1 h-5 w-5 ${
                      VolunteerMenu ? "rotate-180" : "rotate-0"
                    } transition-all delay-200 md:h-4 md:w-4`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
                <AnimatePresence>
                  {VolunteerMenu && (
                    <motion.div
                      initial={{
                        opacity: 0,
                      }}
                      animate={{
                        opacity: 1,
                        transition: {
                          duration: 0.2,
                          ease: "easeInOut",
                        },
                      }}
                      exit={{
                        opacity: 0,
                        transition: {
                          delay: 0.2,
                          ease: "easeInOut",
                        },
                      }}
                      className="absolute right-1/2 top-[38px] z-10 grid min-w-max max-w-md translate-x-[50%] grid-cols-2 rounded-b-lg text-sm md:grid-cols-3"
                      style={{ backgroundColor: currentDropdown }}
                      onMouseEnter={() => setVolunteerMenu(true)}
                      onMouseLeave={() => setVolunteerMenu(false)}
                      title="Click to change the theme"
                    >
                      <div
                        className="absolute top-[-15px] left-1/2 translate-x-[-50%] border-r-[15px] border-b-[15px] border-l-[15px] border-l-transparent border-r-transparent"
                        style={{ borderBottomColor: currentDropdown }}
                      ></div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4">
                          <li className="text-center">
                            <NavLink to="/soon">Volunteer</NavLink>
                          </li>
                        </ul>
                      </div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4"></ul>
                      </div>
                      <div className="p-4 pb-0 md:pb-4">
                        <ul className="space-y-4"></ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
            </ul>
          </div>
          <NavLink
            to="/contact"
            className="hidden rounded-lg border-2 px-4 py-2 text-sm font-medium transition-all lg:block"
            style={{
              backgroundColor: currentColor,
              color: currentBG,
              borderColor: currentColor,
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = "unset";
              e.target.style.backgroundColor = "unset";
              e.target.style.color = "unset";
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = currentColor;
              e.target.style.backgroundColor = currentColor;
              e.target.style.color = currentBG;
            }}
          >
            Contact Us
          </NavLink>
          <button
            data-collapse-toggle="mega-menu"
            type="button"
            className="inline-flex items-center rounded-lg text-sm focus:outline-none lg:hidden"
            aria-controls="mega-menu"
            aria-expanded="false"
            onClick={() => menuBarRef.current.toggleMenu()}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              aria-hidden="true"
              className="h-7 w-7"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
      <AnimatePresence>
        {width >= 450 ? (
          <Sidebar
            ref={menuBarRef}
            commerceMenu={commerceMenu}
            setCommerceMenu={setCommerceMenu}
            financialMenu={financialMenu}
            setFinancialMenu={setFinancialMenu}
            VolunteerMenu={VolunteerMenu}
            setVolunteerMenu={setVolunteerMenu}
            BusinessMenu={BusinessMenu}
            setBusinessMenu={setBusinessMenu}
            currentDropdown={currentDropdown}
            currentBG={currentBG}
            currentText={currentText}
            current={context.current}
            setCurrent={context.setCurrent}
          />
        ) : (
          <TopBar
            ref={menuBarRef}
            commerceMenu={commerceMenu}
            setCommerceMenu={setCommerceMenu}
            financialMenu={financialMenu}
            setFinancialMenu={setFinancialMenu}
            VolunteerMenu={VolunteerMenu}
            setVolunteerMenu={setVolunteerMenu}
            BusinessMenu={BusinessMenu}
            setBusinessMenu={setBusinessMenu}
            currentDropdown={currentDropdown}
            currentBG={currentBG}
            currentText={currentText}
            current={context.current}
            setCurrent={context.setCurrent}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
